// @flow
import * as React from 'react'
import AutofocusElement from '../../../core/AutofocusElement'
import LazyListRenderer from '../../../core/Dropdown/LazyListRenderer'
import NaiveListRenderer from '../../../core/Dropdown/NaiveListRenderer'
import BaseField from '../../../core/BaseField'
import Lightbox from '../../../core/Lightbox'
import DesktopSelectField from '../DesktopSelectField'
import SelectInput from '../SelectInput'
import Field from '../../Field'
import {
  Container,
  OptionsLoadingWrapper,
  OptionWrapper,
  InputContainer,
  PlaceholderTitle,
  FieldContainer,
} from './elements'

// Types
import type { Props as SelectFieldProps } from '../DesktopSelectField'

export type Props = SelectFieldProps

/**
 * Simple pretty select input field that can be used to showed
 * simple selectors.
 */
class MobileSelectField extends React.Component<Props> {
  static defaultProps = DesktopSelectField.defaultProps

  lightboxController = null

  hideOptions() {
    this.lightboxController && this.lightboxController.close()
  }

  handleInputClick = () => {
    this.lightboxController && this.lightboxController.open()
  }

  handleCloseLightbox = () => {
    const { onHidePopper, onCloseMobileSelector } = this.props
    onHidePopper && onHidePopper()
    onCloseMobileSelector && onCloseMobileSelector()
  }

  handleClickItem = (value: any, index: number) => {
    const {
      input: { onChange, onBlur },
    } = this.props
    onChange && onChange(value, index)

    // In next cycle, because we need to wait when react state
    // of ControlledSearchableSelectField will be updated after
    // onChange event
    setTimeout(() => {
      onBlur && onBlur()
      this.hideOptions()
    }, 0)
  }

  handleClickSearchClear = () => {
    const {
      input: { onChange },
    } = this.props
    onChange && onChange('')
  }

  renderLightbox = () => {
    const {
      appearance,
      label,
      options,
      optionSize,
      renderOption,
      renderValue,
      emptyValue,
      meta,
      input,
      placeholder,
    } = this.props

    const listProps = {
      options,
      optionSize,
      renderOption,
      OptionWrapper,
      maxHeight: 'auto',
      focusedIndex: -1,
      onOptionClick: this.handleClickItem,
    }

    const ListComponent = optionSize ? LazyListRenderer : NaiveListRenderer

    return (
      <Container>
        {this.props.combobox && (
          <FieldContainer>
            {placeholder && <PlaceholderTitle>{placeholder}</PlaceholderTitle>}
            <Field
              input={{
                value: input.value,
                onChange: input.onChange,
              }}
              render={(props) => (
                <AutofocusElement
                  render={({ setFocusableRef }) => (
                    <BaseField
                      {...props}
                      innerRef={setFocusableRef}
                      meta={{
                        ...props.meta,
                        loading: meta.loading,
                      }}
                      emptyValue={emptyValue}
                      renderOption={renderOption}
                      renderValue={renderValue}
                      renderInput={(inputProps) => (
                        <SelectInput {...inputProps} />
                      )}
                      label={label}
                      appearance={appearance}
                      onClickClear={this.handleClickSearchClear}
                    />
                  )}
                />
              )}
            />
          </FieldContainer>
        )}
        <OptionsLoadingWrapper $loading={meta.loading}>
          {!!options && options.length > 0 && <ListComponent {...listProps} />}
        </OptionsLoadingWrapper>
      </Container>
    )
  }

  renderInput = (props: any) => {
    const { focusableRef } = this.props

    return (
      <InputContainer>
        <SelectInput
          {...props}
          input={{
            value: props.input.value,
            onClick: props.input.onClick,
          }}
          innerRef={focusableRef}
        />
        <Lightbox
          controllerRef={(c) => (this.lightboxController = c)}
          onClose={this.handleCloseLightbox}
          render={this.renderLightbox}
          appearance="mobile"
          enableAnimation={false}
        />
      </InputContainer>
    )
  }

  render() {
    return (
      <BaseField
        selectable
        {...this.props}
        input={{
          ...this.props.input,
          onClick: this.handleInputClick,
        }}
        renderInput={this.renderInput}
        type="static"
      />
    )
  }
}

export default MobileSelectField
